import { Flex, Text } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

interface ComparisonPaywallHeaderProps {
  tierName: string;
}

export function ComparisonPaywallHeader({ tierName }: ComparisonPaywallHeaderProps) {
  return (
    <Flex direction="column" gap="md" alignItems="center" px="sm" py="md" width="100%">
      <Text
        variant={{ base: 'heading-xl', md: 'heading-2xl' }}
        textAlign="center"
        letterSpacing="-0.05em"
      >
        {translate({
          singular: 'Go {TIER_NAME}',
          replacements: { TIER_NAME: tierName },
        })}
      </Text>
      <Text variant="heading-sm" fontWeight="medium" color="text-primary" textAlign="center">
        {translate('Unlock more tools to create, manage, and share video.')}
      </Text>
    </Flex>
  );
}
